module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.controlerBtnSubmit) ? _c('vue-excel-xlsx', {
    staticClass: "btn btn-primary",
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "filename": 'planilha_geral',
      "sheetname": 'sheetname'
    }
  }, [_vm._v("\n    Resumo de SLA\n  ")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando planilha...")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-89807412!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planilha/planilhaGeral/ExportSla.vue
// module id = 1014
// module chunks = 1